/* Native Shopify forms (contact, B2B inquiry, sign-up): protection against sending the same message twice and focus on the
   result message. The forms post and reload without this file; it only adds two conveniences.

   - A form marked data-form-guard locks its submit buttons once the browser has accepted the input (invalid fields never
     reach the submit event) and shows the optional data-busy-label. A second click or Enter press is ignored.
   - After the reload, the result message (data-form-status, success or error) takes focus once so that keyboard and
     screen reader users arrive at it. Shopify returns the page anchored to the form, so no scrolling is needed. */
(() => {
  if (window.kvsFormGuardInitialized) return;
  window.kvsFormGuardInitialized = true;

  const submitButtons = (form) => form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');
  // Only a marked label span is replaced, so icons inside the button stay intact.
  const labelOf = (button) => button.querySelector('[data-submit-label]');

  function lock(form) {
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    for (const button of submitButtons(form)) {
      button.setAttribute('aria-disabled', 'true');
      const busy = form.dataset.busyLabel;
      const label = labelOf(button);
      if (busy && label && !('idleLabel' in button.dataset)) {
        button.dataset.idleLabel = label.textContent;
        label.textContent = busy;
      }
    }
  }

  function unlock(form) {
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    for (const button of submitButtons(form)) {
      button.removeAttribute('aria-disabled');
      if ('idleLabel' in button.dataset) {
        const label = labelOf(button);
        if (label) label.textContent = button.dataset.idleLabel;
        delete button.dataset.idleLabel;
      }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-form-guard]')) return;
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    // Another handler may cancel the submit; lock only when it really goes ahead (after the event has been dispatched).
    setTimeout(() => {
      if (!event.defaultPrevented) lock(form);
    }, 0);
  });

  // A page restored from the back/forward cache must not keep a locked form.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelectorAll('[data-form-guard][data-submitting]').forEach(unlock);
  });

  const focusStatus = () => {
    const status = document.querySelector('[data-form-status]');
    if (status && !status.contains(document.activeElement)) status.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusStatus, { once: true });
  else focusStatus();
})();
